import { GAMES } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";

// Games & activities — words only, reused on Home and the Games page
export default function GamesSection({ heading = true }) {
  return (
    <section data-testid="games-section" className="bg-forest py-14 text-ivory md:py-20">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal><p className="mb-3 text-sm uppercase tracking-widest-2 text-gold md:text-base">Play &amp; Unwind</p></Reveal>
        {heading && (
          <h2 className="font-display text-4xl font-bold leading-tight tracking-tight text-ivory sm:text-5xl md:text-6xl">Games &amp; Activities</h2>
        )}
        <p className="mt-4 max-w-2xl text-ivory/75">Beyond the bonfire, there is always something to play. Our games corner keeps couples, families and groups entertained late into the night.</p>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {GAMES.map((g) => (
            <div key={g.name} className="rounded-2xl border border-ivory/15 bg-ivory/5 p-7 transition-colors hover:bg-ivory/10">
              <span className="text-3xl" aria-hidden="true">{g.icon}</span>
              <h3 className="mt-3 font-display text-2xl font-bold text-ivory">{g.name}</h3>
              <p className="mt-2 text-ivory/70">{g.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
